export default "__VITE_ASSET__DPZZd5FL__"